import { UseTypingPlaceholderOptions } from '@/interfaces/UseTypingPlaceholderOptions'
import { useEffect, useRef, useState } from 'react'

export function useTypingPlaceholder ({ inputValue, modelList, brandSelected, soundUrl = '/type-sound.mp3', enabled = true }: UseTypingPlaceholderOptions) {
  const [typingPlaceholder, setTypingPlaceholder] = useState('')
  const [showCursor, setShowCursor] = useState(true)
  const typeSound = useRef<HTMLAudioElement | null>(null)
  const typingRefs = useRef({
    interval: null as ReturnType<typeof setTimeout> | null,
    timeout: null as ReturnType<typeof setTimeout> | null,
    cursorBlink: null as ReturnType<typeof setTimeout> | null,
    running: false
  })

  // Detengo la animación y el sonido al escribir o si lo tengo deshabilitado por pais/seller
  useEffect(() => {
    const modeloInputVacio = inputValue === ''
    if (!enabled || !modeloInputVacio) {
      setTypingPlaceholder('')
      const refs = typingRefs.current
      if (refs.interval) clearInterval(refs.interval)
      if (refs.timeout) clearTimeout(refs.timeout)
      refs.running = false
      if (typeSound.current) {
        typeSound.current.pause()
        typeSound.current.currentTime = 0
      }
    }
  }, [inputValue, enabled])

  // Animo el placeholder solo si input vacío y activo
  useEffect(() => {
    if (!enabled) return
    if (!typeSound.current) {
      typeSound.current = new Audio(soundUrl)
      typeSound.current.volume = 0.2
    }
    const refs = typingRefs.current
    if (refs.cursorBlink) clearInterval(refs.cursorBlink)
    refs.cursorBlink = setInterval(() => {
      setShowCursor((prev) => !prev)
    }, 500)

    const modeloInputVacio = inputValue === ''
    if (!modeloInputVacio) {
      setTypingPlaceholder('')
      if (refs.interval) clearInterval(refs.interval)
      if (refs.timeout) clearTimeout(refs.timeout)
      refs.running = false
      if (typeSound.current) {
        typeSound.current.pause()
        typeSound.current.currentTime = 0
      }
      return () => {
        if (refs.interval) clearInterval(refs.interval)
        if (refs.timeout) clearTimeout(refs.timeout)
        if (refs.cursorBlink) clearInterval(refs.cursorBlink)
        refs.running = false
        if (typeSound.current) {
          typeSound.current.pause()
          typeSound.current.currentTime = 0
        }
      }
    }
    let i = 0
    const pickRandomModel = () => {
      if (modelList && modelList.length > 0) {
        const random = Math.floor(Math.random() * modelList.length)
        const model = modelList[random]
        return model.model || model.label || ''
      }
      return 'Escriba su modelo aqui...'
    }
    const startTyping = () => {
      refs.running = true
      const randomPlaceholder = pickRandomModel()
      i = 0
      refs.interval = setInterval(() => {
        const modeloInputVacioNow = inputValue === ''
        if (!modeloInputVacioNow) {
          setTypingPlaceholder('')
          if (refs.interval) clearInterval(refs.interval)
          if (refs.timeout) clearTimeout(refs.timeout)
          refs.running = false
          if (typeSound.current) {
            typeSound.current.pause()
            typeSound.current.currentTime = 0
          }
          return
        }
        setTypingPlaceholder(randomPlaceholder.slice(0, i))
        if (
          brandSelected &&
          modeloInputVacioNow &&
          i > 0 && i <= randomPlaceholder.length && typeSound.current
        ) {
          typeSound.current.pause()
          typeSound.current.currentTime = 0
          typeSound.current.play()
        }
        i++
        if (i > randomPlaceholder.length) {
          if (refs.interval) clearInterval(refs.interval)
          refs.timeout = setTimeout(() => {
            setTypingPlaceholder('')
            startTyping()
          }, 1800)
        }
      }, 180)
    }
    startTyping()
    return () => {
      if (refs.interval) clearInterval(refs.interval)
      if (refs.timeout) clearTimeout(refs.timeout)
      if (refs.cursorBlink) clearInterval(refs.cursorBlink)
      refs.running = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modelList, inputValue, brandSelected, enabled])

  return { typingPlaceholder, showCursor }
}
